/* tslint:disable */
/* eslint-disable */
/**
 * MachineGo P1 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AuthorizedSellerContact,
    AuthorizedSellerContactFromJSON,
    AuthorizedSellerContactFromJSONTyped,
    AuthorizedSellerContactToJSON,
} from './AuthorizedSellerContact';

/**
 * 
 * @export
 * @interface LessorCompanyAuthorizedSellerInfoModel
 */
export interface LessorCompanyAuthorizedSellerInfoModel {
    /**
     * 
     * @type {Array<AuthorizedSellerContact>}
     * @memberof LessorCompanyAuthorizedSellerInfoModel
     */
    authorisedLessors?: Array<AuthorizedSellerContact> | null;
}

export function LessorCompanyAuthorizedSellerInfoModelFromJSON(json: any): LessorCompanyAuthorizedSellerInfoModel {
    return LessorCompanyAuthorizedSellerInfoModelFromJSONTyped(json, false);
}

export function LessorCompanyAuthorizedSellerInfoModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): LessorCompanyAuthorizedSellerInfoModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'authorisedLessors': !exists(json, 'authorisedLessors') ? undefined : (json['authorisedLessors'] === null ? null : (json['authorisedLessors'] as Array<any>).map(AuthorizedSellerContactFromJSON)),
    };
}

export function LessorCompanyAuthorizedSellerInfoModelToJSON(value?: LessorCompanyAuthorizedSellerInfoModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'authorisedLessors': value.authorisedLessors === undefined ? undefined : (value.authorisedLessors === null ? null : (value.authorisedLessors as Array<any>).map(AuthorizedSellerContactToJSON)),
    };
}

